import { Link } from 'react-router-dom';
import { FadeInSection } from '@/hooks/useAnimation';

export default function GroupBuy() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20sunlit%20farmers%20market%20scene%20with%20wooden%20crates%20of%20colorful%20fresh%20melons%20and%20fruits%2C%20soft%20diffused%20golden%20light%2C%20rustic%20wooden%20tables%2C%20green%20leaves%20decoration%2C%20artistic%20atmospheric%20photography%20with%20warm%20golden%20and%20natural%20green%20tones&width=1800&height=600&seq=groupbuy-bg&orientation=landscape"
          alt="团购优惠背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-secondary-500/85"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <FadeInSection className="flex-1" direction="left">
            <div className="text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-4">
                限时特惠
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-background-50 mb-4">
                企业团购 · 量大优惠
              </h2>
              <p className="text-sm md:text-base text-background-50/85 max-w-md mx-auto lg:mx-0 leading-relaxed mb-6">
                企业下午茶、员工福利、客户答谢，瓜瓜基地为您提供定制化团购方案。
                满10箱享9折，满30箱享8折，专属客服一对一服务。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 lg:justify-start">
                <Link
                  to="/about"
                  className="w-full sm:w-auto px-8 py-3 rounded-full bg-background-50 text-secondary-600 text-base font-semibold hover:bg-background-50/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  咨询团购
                </Link>
                <span className="text-sm text-background-50/70">客服热线：400-888-6666</span>
              </div>
            </div>
          </FadeInSection>
          <FadeInSection className="flex-1" delay={200} direction="right">
            <div className="grid grid-cols-2 gap-3 md:gap-4 w-full max-w-md mx-auto">
              <div className="bg-background-50/15 backdrop-blur-sm rounded-2xl p-4 md:p-5 text-center hover:bg-background-50/20 transition-colors">
                <p className="text-3xl md:text-4xl font-bold text-background-50">9折</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">满10箱</p>
              </div>
              <div className="bg-background-50/15 backdrop-blur-sm rounded-2xl p-4 md:p-5 text-center hover:bg-background-50/20 transition-colors">
                <p className="text-3xl md:text-4xl font-bold text-background-50">8折</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">满30箱</p>
              </div>
              <div className="bg-background-50/15 backdrop-blur-sm rounded-2xl p-4 md:p-5 text-center hover:bg-background-50/20 transition-colors">
                <p className="text-3xl md:text-4xl font-bold text-accent-300">7折</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">满50箱</p>
              </div>
              <div className="bg-background-50/15 backdrop-blur-sm rounded-2xl p-4 md:p-5 text-center hover:bg-background-50/20 transition-colors">
                <p className="text-xl md:text-2xl font-bold text-background-50">定制</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">企业专属方案</p>
              </div>
            </div>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}